<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('userCenter.txt1')}}</span>
        <span>{{$t('userCenter.txt2')}}</span>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('userCenter.txt2')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('userCenter.txt3')}}</div>
        </div>
      </div>
      <div class="userForm">
        <div class="cell">
          <span class="labelTxt">{{$t('userCenter.txt4')}}</span>
          <div class="flexCenter">
            <span class="valueTxt">{{queryData.userName}}</span>
            <span class="handleTxt"></span>
          </div>
        </div>
        <div class="cell">
          <span class="labelTxt">{{$t('userCenter.txt5')}}</span>
          <div class="flexCenter">
            <span class="valueTxt"><el-input v-model="queryData.realName" :placeholder="$t('userCenter.txt6')"></el-input></span>
            <span class="handleTxt" @click="onEditRealName">{{$t('userCenter.txt7')}}</span>
          </div>
        </div>
        <div class="cell">
          <span class="labelTxt">{{$t('userCenter.txt8')}}</span>
          <div class="flexCenter">
            <span class="valueTxt passwordTxt">●●●●●●●●●●</span>
            <span class="handleTxt" @click="onEditPassword">{{$t('userCenter.txt9')}}</span>
          </div>
        </div>
        <div class="cell">
          <span class="labelTxt">{{$t('userCenter.txt10')}}</span>
          <div class="flexCenter">
            <span class="valueTxt">{{queryData.mobile | replacestar}}</span>
            <span class="handleTxt" @click="onEditPhone">{{queryData.mobile?$t('userCenter.txt11'):$t('userCenter.txt12')}}</span>
          </div>
        </div>
        <div class="cell">
          <span class="labelTxt">{{$t('userCenter.txt13')}}</span>
          <div class="flexCenter">
            <span class="valueTxt">{{queryData.email | emailStar}}</span>
            <span class="handleTxt" @click="onEditEmail">{{queryData.email?$t('userCenter.txt14'):$t('userCenter.txt15')}}</span>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import axios from "axios";
  import qs from 'qs';
  export default {
    data() {
        return {
          queryData:{},
     };
   },
   created() {
    this.infoDetail();
  },
  filters: {
  },
  methods: {
      // 获取用户信息
      async infoDetail() {
        const { data: res } = await this.$http.get('/user/info/detail');
        this.queryData = {
          ...res.result
        }
      },
      // 修改用户真实姓名
      async onEditRealName(){
        let data = {
          realName:this.queryData.realName,
          userId:this.queryData.id
        }
        const { data: res } = await this.$http.post("/user/info/update/realName?"+qs.stringify(data));
        if(!res.success){
					return this.$message.error(res.message);
				}
        this.$message.success(this.$t('userCenter.txt16'))
      },
      onBack(){
        this.$router.go(-1);
      },
      // 修改密码
      onEditPassword(){
        this.$router.push("/editPassword");
      },
      // 修改手机号
      onEditPhone(){
        this.$router.push("/editPhone");
      },
      // 修改邮箱
      onEditEmail(){
        this.$router.push("/editEmail");
      },
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .userPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .w350{
      width: 350px;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    .userForm{
      width: 50%;
      margin: 30px auto 130px auto;
      display: block;
      .cell:first-of-type{
        margin-top: 0px;
      };
      .cell{
        margin-bottom: 20px;
        margin-top: 40px;
        .labelTxt{
          font-size: 14px;
          font-weight: 500;
          color: #AEB0B9;
          display: block;
          margin-bottom: 20px;
        }
        .valueTxt{
          font-size: 16px;
          color: #222222;
        }
        .passwordTxt{
          color: #1B3B7C;
        }
        .handleTxt{
          font-size: 14px;
          cursor: pointer;
          font-weight: 500;
          color: #1B3B7C;
        }
      }
    }
  }

</style>
